<template>
    <div class="container-styles">
        <div class="buly"></div>
        <div class="partner title text-mhblue">Týmy MH Superligy</div>
        <div class="puck-container">
            <v-row justify="center" align="center">
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="left">
                        <v-img src="/img/teams/griffins/griffins_small.png" height="80px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="right">
                        <v-img src="/img/teams/los-bomberos/los-bomberos_small.png" height="100px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="left">
                        <v-img src="/img/teams/raptors/raptors_small.png" height="100px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="right">
                        <v-img src="/img/teams/red-wheels/red-wheels_small.png" height="100px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="left">
                        <v-img src="/img/teams/rockets/rockets_small.png" height="100px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="right">
                        <v-img src="/img/teams/dark-clowns/dark-clowns_small.png" height="100px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="left">
                        <v-img src="/img/teams/spitfires/spitfires_small.png" height="100px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="right">
                        <v-img src="/img/teams/hunters/hunters_small.png" height="100px"></v-img>
                    </div>
                </v-col>
                <v-col cols="12" sm="3" class="d-flex justify-center">
                    <div class="team-puck puck" data-direction="left">
                        <v-img src="/img/teams/black-hawks/black-hawks_small.png" height="100px"></v-img>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

const animatePucksOnScroll = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const element = entry.target as HTMLElement;
                const direction = element.getAttribute('data-direction');
                element.classList.add(direction === 'left' ? 'fly-left' : 'fly-right');
                observer.unobserve(element); // Odpozorovat po animaci
            }
        });
    });

    const pucks = document.querySelectorAll('.puck');
    pucks.forEach((puck) => observer.observe(puck));
};

onMounted(() => {
    animatePucksOnScroll();
});
</script>

<style scoped>
.buly{
    position: relative ;
    width: 60px;
    height: 60px;
    top:-92px;
    left: 50%;
    transform: translate(-50%, 0);
    border-radius: 30px;
    background-color: rgba(0, 0, 255, 0.8);
}



.puck-container {
    width: 100%;
    padding: 20px;
}

.container-styles {
    background-image: url('@/assets/img/backgrounds/bitmapa_ice.jpg');
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 80px 50px;
}

.team-puck {
    margin: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    min-width: 150px;
    min-height: 150px;
    border-radius: 50%;
    padding: 20px;
    border: 3px solid rgba(255, 0, 0, 0.1);
    background-color: rgba(20, 20, 20, 1);
    transition: transform 0.3s ease;
    z-index: 1000;
    box-shadow: 10px 20px 10px rgba(0, 0, 0, 0.4);
    opacity: 0; /* Skrytý puk před animací */
}

@keyframes fly-left {
    0% {
        transform: translateX(-300px);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes fly-right {
    0% {
        transform: translateX(300px);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.fly-left {
    animation: fly-left 0.8s ease forwards;
}

.fly-right {
    animation: fly-right 0.8s ease forwards;
}
</style>
